import { MateCardFactoryGenerateType } from "@/enums/chatEnums";
import { get, post, put, deleteOne, fetchStream } from "@/modules/request";
import {
  ItemResponse,
  PageRequest,
  PageResponse,
  Response,
  WriteResponse,
} from "@/types/api-types";
import {
  Mate,
  MateRoleplayAnswer,
  RoleplayQuestion,
  RoleplayQuestionCategory,
} from "@/types/entity";

export const ApiGetRoleplayQuestionPage = (
  params: PageRequest<{ categoryId?: number }>
): Promise<PageResponse<RoleplayQuestion>> =>
  get("/RoleplayQuestionPage", params);

export const ApiGetRoleplayQuestionMatePage = (
  params: PageRequest<{
    mateId?: number;
    categoryId?: number;
    type: "all" | "answered" | "unanswered";
  }>
): Promise<PageResponse<RoleplayQuestion>> =>
  get("/RoleplayQuestion/ReadMatePage", params);

export const ApiGetRoleplayQuestion = (
  uuid: string
): Promise<WriteResponse<RoleplayQuestion>> => get(`/RoleplayQuestion/${uuid}`);

export const ApiRoleplayQuestionCompleteAnswer = (
  id: number,
  params: {
    mateId: number;
    type: MateCardFactoryGenerateType;
    answer: string;
  },
  cb: (res: string | Response<{ text: string }>) => void
): Promise<void> =>
  fetchStream(`/RoleplayQuestionCompleteAnswer/${id}`, "post", params, cb);

export const ApiGetRoleplayQuestionCategoryAll = (params?: {
  mateId: number;
}): Promise<ItemResponse<RoleplayQuestionCategory>> =>
  get("/RoleplayQuestionCategory/ReadAll", params);

export const ApiGetRoleplayQuestionCategoryLatestAnswered = (): Promise<
  Response<{
    mate: Mate;
    item: RoleplayQuestionCategory;
  }>
> => get("/RoleplayQuestionCategory/ReadLatestAnswered");

export const ApiGetRoleplayQuestionCategory = (
  uuid: string
): Promise<
  Response<{
    matezz: Array<Mate & { answerProgressPercent: number }>;
    item: RoleplayQuestionCategory;
  }>
> => get(`/RoleplayQuestionCategory/${uuid}`);

export const ApiGetMateRoleplayAnswerPage = (
  params: PageRequest<{ mateId: number }>
): Promise<PageResponse<MateRoleplayAnswer>> =>
  get("/MateRoleplayAnswerPage", params);

export const ApiGetMateRoleplayAnswer = (
  id: number
): Promise<WriteResponse<MateRoleplayAnswer>> =>
  get(`/MateRoleplayAnswer/${id}`);

export const ApiCreateMateRoleplayAnswer = (
  params: Partial<MateRoleplayAnswer>
): Promise<WriteResponse<MateRoleplayAnswer>> =>
  post("/MateRoleplayAnswer", params);

export const ApiUpdateMateRoleplayAnswer = (
  id: number,
  params: Pick<MateRoleplayAnswer, "text" | "visibility" | "audioMediaId">
): Promise<WriteResponse<MateRoleplayAnswer>> =>
  put(`/MateRoleplayAnswer/${id}`, { ...params, dtUpdate: new Date() });

export const ApiDeleteMateRoleplayAnswer = (
  id: number
): Promise<WriteResponse<null>> => deleteOne(`/MateRoleplayAnswer/${id}`);
